import React from 'react';
import './People.css';
import { Link } from 'react-router-dom';
import usePeople from '../../hooks/usePeople'; 
import Footer from '../Footer';


const People = () => {
  const { people, pastCollaborators, loading, error } = usePeople();

  if (loading) {
    return (
      <div>
        <div className="header">
          <div className="wall-container-people">
            <video className="bg-video-people" autoPlay muted loop playsInline>
              <source src={process.env.PUBLIC_URL + '/videos/Austin-2.mp4'} />
            </video>
          </div>
        </div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading team members...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <div className="header">
          <div className="wall-container-people">
            <video className="bg-video-people" autoPlay muted loop playsInline>
              <source src={process.env.PUBLIC_URL + '/videos/Austin-2.mp4'} />
            </video>
          </div>
        </div>
        <div className="error-container">
          <p>Failed to load team members: {error.message}</p>
        </div>
      </div>
    );
  }

  const renderTeamMembers = (members) => {
    return members.map((member, index) => {
      // Split the name into first and last name
      const fullName = member.name.trim();
      const [firstName, lastName] = fullName.split(' ');

      // Create a link based on the formatted name
      const formattedName = fullName.replace(/\s+/g, "_").toLowerCase();
      const linkTo = `/team/${formattedName}`;

      return (
          <div className="team-member">
             <Link key={index} to={linkTo}>
             <div className="member-content"> 
              <img src={member.image} alt={`Member ${index}`} />
              <div className="member-info">
              <p className="name">{fullName}</p>
                {member.title && <p className="title">{member.title}</p>}

                {/* Project Titles */}
                {member.projectsCategory && member.projectsCategory.length > 0 && (
                  <div>
                    {member.projectsCategory.map((project, idx) => (
                      <p key={idx} className="project-title">{project}</p>
                    ))}
                  </div>
                )}
              </div>
            </div>
            </Link>
          </div>
      );
    });
  };

  return (
      <>
      <div>
      <div className="header">
        <div className="wall-container-people">
          <video className="bg-video-people" autoPlay muted loop  playsInline>
            <source src={process.env.PUBLIC_URL + '/videos/Austin-2.mp4'} />
            </video>
      </div>
      <h1>Meet the Team</h1>
      </div>

      <div className="meet-the-team">
      <section className="team-section">
      <h2>Current Team</h2>
      <div className="team-members">
      {renderTeamMembers(people)}
      </div>
      </section>

      {pastCollaborators && pastCollaborators.length > 0 && (
        <section className="team-section">
        <h2>Past Collaborators</h2>
        <div className="team-members">
        {renderTeamMembers(pastCollaborators)}
        </div>
        </section>
      )}
      </div>
      
      </div>
      <Footer />
      </>
      );     
      };     

export default People;